import { render, staticRenderFns } from "./VtkAreaTree.vue?vue&type=template&id=30b3aac2&scoped=true"
import script from "./VtkAreaTree.vue?vue&type=script&lang=js"
export * from "./VtkAreaTree.vue?vue&type=script&lang=js"
import style0 from "./VtkAreaTree.vue?vue&type=style&index=0&id=30b3aac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3aac2",
  null
  
)

export default component.exports